import Button from '@mui/material/Button';
import { TypeOfAppointment } from '../../../../../features/calendar/calendar-slice';
import { formatDateLabel, getDay, getShortMonth, scheduleIsEnded } from '../../../../../lib/dayjs';
import { ISchedules } from '../../../../../services/journey.service';
import { Typography } from '@mui/material';
import { Appointment, Content, ItemAction, ItemContent, Root, ShortDate } from './styled';
import { ReactComponent as VideoCamera } from '../../../../../images/videocamera.svg';
import { ReactComponent as Location } from '../../../../../images/location_on.svg';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

interface Props {
  schedule: ISchedules;
  openCalendar: (schedule: ISchedules) => Promise<void>;
}

const Schedule = ({ schedule, openCalendar }: Props) => {
  return (
    <>
      <Root className={`${scheduleIsEnded(schedule?.dateEnd) ? 'past' : 'future'}`}>
        <ItemContent>
          <ShortDate>
            <span>{getDay(schedule.dateStart)}</span>
            <span>{getShortMonth(schedule.dateStart)}</span>
          </ShortDate>
          <Content>
            <Typography variant="body1B" sx={{ color: 'brand.darkGreen' }}>
              {schedule.calendarServiceType.name}
            </Typography>
            <Typography variant="body1R">{formatDateLabel(schedule.dateStart)}</Typography>
            <Typography variant="body1R">Dra {schedule.user.name} </Typography>

            {schedule.calendar.type === TypeOfAppointment.VIRTUAL_CONSULTATION && (
              <Typography variant="body1B" sx={{ color: 'brand.darkGreen' }}>
                <Appointment>
                  <VideoCamera /> Online
                </Appointment>
              </Typography>
            )}
            {schedule.calendar.type === TypeOfAppointment.PHYSICAL_APPOINTMENT ||
            schedule.calendar.type === TypeOfAppointment.PROCEDURE ||
            schedule.calendar.type === TypeOfAppointment.EXAM ? (
              <>
                {schedule.address ? (
                  <>
                    <Typography variant="body1B" sx={{ color: 'brand.darkGreen' }}>
                      <Appointment>
                        <Location /> {schedule.address.alias}
                      </Appointment>
                    </Typography>
                    {schedule.address.address ? (
                      <Typography variant="body2R">{`${schedule.address.address}, ${schedule.address.addressNumber}.`}</Typography>
                    ) : null}
                    {schedule.address.neighborhood ? (
                      <Typography variant="body2R">{`${schedule.address.neighborhood}, ${schedule.address.city}/${schedule.address.state}`}</Typography>
                    ) : null}
                  </>
                ) : (
                  <Typography variant="body1B" sx={{ color: 'brand.darkGreen' }}>
                    <Appointment>
                      <Location /> A definir
                    </Appointment>
                  </Typography>
                )}
              </>
            ) : (
              []
            )}
          </Content>
        </ItemContent>

        {!scheduleIsEnded(schedule?.dateEnd) && schedule.type === 'VIRTUAL_CONSULTATION' && (
          <ItemAction>
            <Button
              href={schedule.teleUrl}
              target="_blank"
              variant="contained"
              color="primary"
              endIcon={<ArrowForwardIcon />}
            >
              Entrar na vídeo chamada
            </Button>
          </ItemAction>
        )}

        {schedule?.allowReschedule && (
          <ItemAction>
            <Button variant="inline" color="primary" onClick={() => openCalendar(schedule)}>
              reagendar
            </Button>
          </ItemAction>
        )}
      </Root>
    </>
  );
};

export default Schedule;
